//Indice para todos los SAGAS
import {all, fork} from "redux-saga/effects";

import * as OpenBankingSaga from "./OpenBankingSaga";

export default function * rootSaga() {
    let allSagas = Object.assign( OpenBankingSaga );

    yield all( [...Object.values(allSagas)].map(fork) );
}